export default {
  namespaced: true,
  state: {
    message: '',
    type: '',
    status: false,
  },
  getters: {
    get: (state) => {
      return state
    },
  },
  mutations: {
    set(state, alert) {
      state.message = alert.message
      state.status = true

      if (alert.type) {
        state.type = alert.type
      }
    },
    clear(state) {
      state.status = false
    },
  },
  actions: {
    alertMessage(context, alert) {
      context.commit('set', alert)
    },
    clear(context) {
      context.commit('clear')
    },
  },
}
